module.exports = __webpack_public_path__ + "img/4.699a2a21.png";